import type { MouseEvent as ReactMouseEvent, ReactNode } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

interface ScrollLinkProps {
  to: string;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

export default function ScrollLink({ to, children, onClick, className }: ScrollLinkProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang = 'en' } = useParams();

  const handleClick = (e: ReactMouseEvent) => {
    e.preventDefault();
    const home = `/${lang}`;
    onClick?.();
    if (location.pathname === home) {
      document.getElementById(to)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(home);
      setTimeout(() => {
        document.getElementById(to)?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    }
  };

  return (
    <a
      href={`#${to}`}
      onClick={handleClick}
      className={
        className ??
        'text-sm font-semibold text-foreground-800 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer'
      }
    >
      {children}
    </a>
  );
}